import { createSelector } from 'reselect'
import { selectIsNewCardDashboardEnabled } from '~/store/flippers/selectors'
import { selectIsCardsDashboardEnabled } from '~/store/userInfo/selectors'

// TODO(sangnv-ptit): move from ProfileConfiguration (STRAITSX-27894)
export const selectShouldShowNewCardDashboard = createSelector(
  [selectIsCardsDashboardEnabled, selectIsNewCardDashboardEnabled],
  (configEnabled, flipperEnabled) => configEnabled && flipperEnabled
)
